import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import './Layout.css';

export function Layout({ children }) {
  const { user, logout, hasGroup, hasAnyGroup } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const navItems = [];

  if (hasAnyGroup(['underwriter', 'leadership'])) {
    navItems.push({ path: '/', label: 'Submission Queue', icon: 'grid' });
    navItems.push({ path: '/accounts', label: 'Accounts', icon: 'folder' });
    navItems.push({ path: '/brokers', label: 'Brokers', icon: 'briefcase' });
    navItems.push({ path: '/products', label: 'Products', icon: 'package' });
    navItems.push({ path: '/approvals', label: 'Approvals', icon: 'check-circle' });
    navItems.push({ path: '---', label: 'PAS', icon: 'divider' });
    navItems.push({ path: '/policies', label: 'Policies', icon: 'file-text' });
    navItems.push({ path: '/commissions', label: 'Commissions', icon: 'dollar-sign' });
    navItems.push({ path: '/compliance', label: 'Compliance', icon: 'shield' });
    navItems.push({ path: '/treaties', label: 'Treaties', icon: 'layers' });
  }

  if (hasGroup('leadership')) {
    navItems.push({ path: '/leadership', label: 'DEX KPIs', icon: 'bar-chart' });
    navItems.push({ path: '/audit-trail', label: 'Audit Trail', icon: 'clipboard' });
  }

  if (hasAnyGroup(['leadership', 'capacity-provider'])) {
    navItems.push({ path: '/capacity-partners', label: 'Capacity Partners', icon: 'users' });
  }

  if (hasGroup('broker')) {
    navItems.push({ path: '/broker', label: 'Submissions', icon: 'upload' });
  }

  // Documentation section - visible to all authenticated internal users
  if (hasAnyGroup(['underwriter', 'leadership'])) {
    navItems.push({ path: '---', label: 'DOCS', icon: 'divider' });
    navItems.push({ path: '/docs', label: 'Documentation', icon: 'book' });
    navItems.push({ path: '/api-docs', label: 'API Reference', icon: 'code' });
  }

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="sidebar-logo">DEX Engine</h1>
          <span className="sidebar-env">MGA Platform</span>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) =>
            item.path === '---' ? (
              <div key={item.label} className="nav-divider">
                <span className="nav-divider-label">{item.label}</span>
              </div>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive(item.path) ? 'nav-item--active' : ''}`}
              >
                <span className="nav-label">{item.label}</span>
              </Link>
            )
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-name">{user?.displayName || user?.email}</span>
            <span className="user-role">
              {user?.groups?.[0] || 'user'}
            </span>
          </div>
          <button className="btn btn--secondary btn--sm" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
}
